export enum EFilterList {
  subject = 'subject',
  contentType = 'contentType',
  level = 'level',
  order = 'order',
  language = 'language',
}

export type TDisplayType = 'checkbox' | 'radio' | 'subjects';

export interface IFilterProperty {
  title: string;
  value: string;
}

export interface ILibraryFilter {
  name: EFilterList | string;
  label: string;
  placeholder?: string;
  children?: ILibraryFilter[];
  type?: TDisplayType;
  property: IFilterProperty;
  options?: any[];
  selected?: any[];
  display?: boolean;
}
